// auth.guard.ts
import { Injectable } from '@angular/core';
import {
   CanActivate,
   ActivatedRouteSnapshot,
   RouterStateSnapshot,
   Router,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
   providedIn: 'root',
})
export class AuthGuard implements CanActivate {
   constructor(private authService: AuthService, private router: Router) { }


   /* canActivate(
   next: ActivatedRouteSnapshot,
   state: RouterStateSnapshot
 ): boolean {
   const guardTime = new Date().toISOString();
   const isLoggedIn = this.authService.estaLogeado();
   console.log(`%c[AuthGuard] canActivate called. Time: ${guardTime}. Target URL: ${state.url}. IsLoggedIn: ${isLoggedIn}`, "color: orange; font-weight: bold;");

   if (isLoggedIn) {
     console.log(`%c[AuthGuard] Access GRANTED. Time: ${guardTime}.`, "color: green;");
     return true;
   } else {
     console.warn(`%c[AuthGuard] Cccess DENIED. IsLoggedIn was false. Time: ${guardTime}.`, "color: red;");
     console.log("[AuthGuard] Calling authService.handleSessionExpiration()...");
     // Temporalmente comenta la siguiente línea para ver si la navegación se cancela sin ella:
     // this.authService.handleSessionExpiration();
     console.warn(`%c[AuthGuard] Returning false. Navigation will be cancelled. Time: ${guardTime}.`, "color: red;");
     return false;
   } */

   canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot
   ): boolean {
      if (this.authService.estaLogeado()) {
         return true; // ok todo, sigue a la page de features que se quería
      } else {
         // TODO: cuando exista la zona privada de congresos, este guard deberá distinguir
         // entre dominio admin y dominio congreso para redirigir al login correcto.
         // Admin -> /auth/login
         // Congreso -> /web/auth/login (por ejemplo, si se decide esa estructura de rutas)
         // Use state object to pass data without showing in URL
         this.authService.handleSessionExpiration(); // BORRAR ESTA LINEA SI SE PONEN LAS 3 SIGUIENTES
         // this.router.navigate(['/auth/login'], {  ESTAS 3 LINEAS COMENTADAS POR EL SESION EXPIRED
         // state: { sessionExpired: true }
         // }); // Sin sesión -> al login con parámetro de sesión caducada
         return false;
      }
   }
}
